import React, { Component } from 'react'
import { assessor } from 'constants/wizards'
import { meta } from 'helpers/decorators'
import { Wizard } from 'components/masters'
import { WizardProgress } from '../../../../components/layout'
import { renderRoutes } from 'react-router-config'

@meta({
  title: 'Register assessor',
  intlKey: 'pageTitle.register_assessor'
})
class Assessor extends Component {
  render() {
    const { route } = this.props
    const children = route && renderRoutes(route.routes)

    return (
      <Wizard
        items={assessor}
        wizardProgress={<WizardProgress {...this.props} />}
        {...this.props}
      >
        {children}
      </Wizard>
    )
  }
}

export default Assessor
